import { Reveal } from "@/components/Reveal";
import { FLAT_RATE } from "@/data";

export const FlatRate = () => (
  <section data-testid="flat-rate-section" className="bg-ice py-16 md:py-24">
    <div className="mx-auto max-w-[1100px] px-5 md:px-10">
      <Reveal>
        <div className="relative overflow-hidden bg-navy noise-overlay px-6 py-14 md:py-20 text-center">
          <div className="absolute -top-16 -right-16 h-56 w-56 rounded-full bg-white/5" />
          <div className="absolute -bottom-20 -left-16 h-64 w-64 rounded-full bg-gold/10" />
          <div className="relative z-10">
            <p className="font-primary uppercase tracking-[0.4em] text-gold text-sm mb-5">{FLAT_RATE.label}</p>
            <h2 className="font-primary font-bold uppercase tracking-tighter text-ice text-4xl md:text-6xl leading-[0.95] mb-6">
              {FLAT_RATE.title}
            </h2>
            <p className="font-body text-ice/80 text-lg md:text-xl max-w-xl mx-auto mb-9">{FLAT_RATE.desc}</p>
            <a
              href="#quote"
              data-testid="flat-rate-book-btn"
              className="inline-block font-primary uppercase text-base tracking-wide bg-gold text-navy px-10 py-4 hover:shadow-[5px_5px_0px_#F4F7F6] transition-shadow"
            >
              Book Today
            </a>
            <p className="font-body text-ice/40 text-xs mt-6">{FLAT_RATE.note}</p>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
